module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/File-cloud-8c2c18d93922e5d9b48b3f28dcfe7d92.svg";